import { ANALYTIC_EVENTS } from "@/const/event.constants"
import { getSpecialSymbol } from "@/organisms/SmartSearch/helpers/option.helpers"
import { ItemListTemplate } from "../../templates/ItemListTemplate"
import { DescriptionItem } from "../DescriptionItem"

import type { ItemListProps } from "./KeyItemList.types"

export const ItemList = (props: ItemListProps) => {
  const { title, Icon, currentValue, items, logger, createHandler } = props
  const className = "item-smart-search-ks key-item-smart-search-ks"

  return (
    <ItemListTemplate title={title} Icon={Icon}>
      {items.map(
        ({ key, label, displayLabel, inequality, strictEquality }: any) => {
          const handler = (event: MouseEvent | KeyboardEvent) => {
            createHandler(() => {
              logger?.info(
                ANALYTIC_EVENTS.TAB.FILTER.ADVANCE_SEARCH.CLICK.KEY,
                {
                  value: key
                }
              )

              const symbol = getSpecialSymbol(currentValue)

              return `${symbol}${displayLabel ?? label}`
            })(event)
          }

          if (inequality || strictEquality) return null

          return (
            <DescriptionItem className={className} key={key} handler={handler}>
              {displayLabel ?? label}
            </DescriptionItem>
          )
        }
      )}
    </ItemListTemplate>
  )
}
